import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {MonkeysGoldParsedInitData} from "../../server/data/MonkeysGoldParsedInitData";

/**
 * Created by Jerker Nord on 2020-09-14.
 */

export class MonkeysGoldSymbolHighLightController extends ReelStopPresentationController {

    private _avalancheSymbolHighlight:boolean[][];

    constructor(index:number) {
        super(index, "MonkeysGoldSymbolHighLightController");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {

    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._avalancheSymbolHighlight = data.avalancheSymbolHighlight;
        MonkeysGoldGameModuleConfig.monkeysGoldAvalancheSymbolAttentionController.resetPlayedSounds();
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._avalancheSymbolHighlight) {
            for(let i:number = 0; i < this._avalancheSymbolHighlight[data.reelId].length; i++) {
                if(this._avalancheSymbolHighlight[data.reelId][i] == true) {
                    MonkeysGoldGameModuleConfig.monkeysGoldAvalancheSymbolAttentionController.playSymbolAttention(data.reelId, this._avalancheSymbolHighlight[data.reelId]);
                    break;
                }
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    public abort():void {
    }
}